<template>
  <div style="width: 100%;height: 100%;background-color: white;" v-loading="showLoading" element-loading-text="登录中...">
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
import { indexModule } from '@/request/welcome.js'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {

  },
  data() {
    // 这里存放数据
    return {
        showLoading:true
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log('****************', this.$route)
    if (this.$route.query.token) {
      this.businesslogin(this.$route.query.token, this.$route.query.ID)
    } else {
      this.$router.push('/login')
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  // 方法集合
  methods: {
    async businesslogin(token, ID) {
      await indexModule.businesslogin({ token, ID }).then((response) => {
        switch (response.data.code) {
          case 100:
            {
              this.$store.dispatch('admin/setAdminID', response.data.result.adminToken)
              this.$store.dispatch('admin/setToken', response.data.result.token)
              this.$store.dispatch('admin/setIsNeedComplate', response.data.result.isNeedComplate)
              this.$store.dispatch('admin/setisNeedEditPwd', response.data.result.isNeedEditPwd)
              this.$store.dispatch('admin/setISSYS', response.data.result.isSys)
              this.$store.dispatch('tab/clearTab')
              if (this.$route.query.backurl) {
                this.$router.push({//你需要接受路由的参数再跳转
                  path: this.$route.query.backurl
                });
              } else {
                this.$router.push('main')
              }
            }
            break;
          default:
            {
                this.$message.error(response.data.message || '服务异常')
            }
            break;
        }
      })
        .catch((error) => { })
        .finally(() => { 
            this.showLoading = false
        })
    },

  },
  // 生命周期 - 创建之前
  beforeCreate() { },
  // 生命周期 - 挂载之前
  beforeMount() { },
  // 生命周期 - 更新之前
  beforeUpdate() { },
  // 生命周期 - 更新之后
  updated() { },
  // 生命周期 - 销毁之前
  beforeDestroy() { },
  // 生命周期 - 销毁完成
  destroyed() { },
  //  // 如果页面有keep-alive缓存功能，这个函数会触发
  activated() { },
}
</script>

<style scoped>
</style>
